module.exports = __webpack_public_path__ + "img/offline-big.d060bc46.svg";